import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-primary" }, "Ligipääsetavuse avaldus", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Alljärgnevalt kirjeldame vastavust ligipääsetavusnõuetele. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Töötame pidevalt ligipääsetavuse parandamiseks")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Praegu on käimas veebilehe ligipääsetavuse hindamine, mille tulemused avaldame niipea, kui analüüs on lõpule viidud. ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tagasiside")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, " Andke ligipääsetavuse kohta tagasisidet kirjutades kasutajatoele. ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Ligipääsetavuse järelevalve asutus")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("p", null, [
      _createTextVNode(" Euroopa Liidus kehtib digiteenuste osutamisel ligipääsetavuse nõue, mis eeldab, et kõik avalikud teenused peavad olema ligipääsetavad. See tähendab et, see vastaks avaliku "),
      _createElementVNode("a", {
        class: "text-primary",
        href: _ctx.ligipaasetavuseNoudeSeadusUrl
      }, "teabe seaduse § 32", 8, _hoisted_5),
      _createTextVNode(" alusel kehtestatud ligipääsetavusnõuetega (need on kehtestatud standardiga "),
      _createElementVNode("a", {
        class: "text-primary",
        href: _ctx.ligipaasetavusStandardUrl
      }, _toDisplayString(_ctx.ligipaasetavusStandardVersion), 9, _hoisted_6),
      _createTextVNode("). ")
    ]),
    _hoisted_7,
    _createElementVNode("p", null, [
      _createTextVNode(" Käesolev avaldus kehtib Justiits- ja Digiministeeriumi hallatavale veebilehe "),
      _createElementVNode("a", {
        class: "text-primary",
        href: _ctx.domeeniUrl
      }, _toDisplayString(_ctx.domeeniUrl), 9, _hoisted_8),
      _createTextVNode(" kohta, mis peab olema ligipääsetav Avaliku teabe seaduse §32 alusel. ")
    ]),
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _createElementVNode("p", null, " E-post: " + _toDisplayString(_ctx.kasutajatugiEmail), 1),
    _createElementVNode("p", null, " Vastame teile tavaliselt " + _toDisplayString(_ctx.kasutajatugiResponseTimeInDays) + " tööpäeva jooksul. ", 1),
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _createElementVNode("p", null, " Avalike teenuste veebide ja rakenduste ligipääsetavuse osas teostab järelevalvet " + _toDisplayString(_ctx.jarelvalveName) + ". ", 1),
    _createElementVNode("p", null, " Veebileht: " + _toDisplayString(_ctx.jarelvalveWebsite), 1),
    _createElementVNode("p", null, " E-post: " + _toDisplayString(_ctx.jarelvalveEmail), 1),
    _createElementVNode("p", null, " Telefon: " + _toDisplayString(_ctx.jarelvalvePhone), 1),
    _hoisted_20,
    _hoisted_21,
    _createElementVNode("p", null, " Käesolev avaldus on koostatud " + _toDisplayString(_ctx.avalduseKoostamiseKp), 1)
  ], 64))
}